import * as api from '@/api/api'
import { isURL } from '@/utils/validate'
import onlineCommons from '@jeecg/antd-online-mini'

export function timeFix() {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : (hour <= 11 ? '上午好' : (hour <= 13 ? '中午好' : (hour < 20 ? '下午好' : '晚上好')))
}

export function welcome() {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了']
  let index = Math.floor((Math.random()*arr.length))
  return arr[index]
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent() {
  let event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

/**
 * 过滤对象中为空的属性
 * @param obj
 * @returns {*}
 */
export function filterObj(obj) {
  if (!(typeof obj == 'object')) {
    return;
  }

  for ( let key in obj) {
    if (obj.hasOwnProperty(key)
      && (obj[key] == null || obj[key] == undefined || obj[key] === '')) {
      delete obj[key];
    }
  }
  return obj;
}

/**
 * 时间格式化
 * @param value
 * @param fmt
 * @returns {*}
 */
export function formatDate(value, fmt) {
  let regPos = /^\d+(\.\d+)?$/;
  if(regPos.test(value)){
    //如果是数字
    let getDate = new Date(value);
    let o = {
      'M+': getDate.getMonth() + 1,
      'd+': getDate.getDate(),
      'h+': getDate.getHours(),
      'm+': getDate.getMinutes(),
      's+': getDate.getSeconds(),
      'q+': Math.floor((getDate.getMonth() + 3) / 3),
      'S': getDate.getMilliseconds()
    };
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (let k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
      }
    }
    return fmt;
  }else{
    //TODO
    value = value.trim();
    return value.substr(0,fmt.length);
  }
}

// 生成首页路由
export function generateIndexRouter(data) {
let indexRouter = [{
          path: '/',
          name: 'dashboard',
          //component: () => import('@/components/layouts/BasicLayout'),
          component: resolve => require(['@/components/layouts/TabLayout'], resolve),
          meta: { title: '首页' },
          redirect: '/dashboard/analysis',
          children: [
            ...generateChildRouters(data)
          ]
        },{
          "path": "*", "redirect": "/404", "hidden": true
        }]
  return indexRouter;
}

// 生成嵌套路由（子路由）

function  generateChildRouters (data) {
  const routers = [];
  for (let item of data) {
    let component = "";
    if(item.component.indexOf("layouts")>=0){
       component = "components/"+item.component;
    }else{
       component = "views/"+item.component;
    }

    // URL 占位符：仅支持白名单内的固定变量，禁止 eval 执行任意代码（原 eval 实现存在菜单数据注入→任意代码执行风险）
    const URL_VAR_WHITELIST = {
      'window._CONFIG.domianURL': () => (window._CONFIG || {}).domianURL || '',
      'window._CONFIG.staticDomainURL': () => (window._CONFIG || {}).staticDomainURL || '',
      'window._CONFIG.pdfDomainURL': () => (window._CONFIG || {}).pdfDomainURL || ''
    }
    let URL = (item.meta.url || '').replace(/\{\{\s*([^}]+?)\s*\}\}/g, (s1, s2) => {
      const getter = URL_VAR_WHITELIST[(s2 || '').trim()]
      if (getter) {
        return String(getter())
      }
      // 白名单外的占位符：不执行，保留原样并提示，便于排查线上特殊菜单
      // eslint-disable-next-line no-console
      console.warn('[菜单URL占位符] 未识别的变量，已原样保留:', s2)
      return s1
    })
    if (isURL(URL)) {
      item.meta.url = URL;
    }

    let componentPath
    if(item.component=="modules/online/cgform/OnlCgformHeadList"){
      componentPath = onlineCommons.OnlCgformHeadList
    }else if(item.component=="modules/online/cgform/OnlCgformCopyList"){
      componentPath = onlineCommons.OnlCgformCopyList
    }else if(item.component=="modules/online/cgform/auto/OnlCgformAutoList"){
      componentPath = onlineCommons.OnlCgformAutoList
    }else if(item.component=="modules/online/cgform/auto/OnlCgformTreeList"){
      componentPath = onlineCommons.OnlCgformTreeList
    }else if(item.component=="modules/online/cgform/auto/erp/OnlCgformErpList"){
      componentPath = onlineCommons.OnlCgformErpList
    }else if(item.component=="modules/online/cgform/auto/tab/OnlCgformTabList"){
      componentPath = onlineCommons.OnlCgformTabList
    }else if(item.component=="modules/online/cgform/auto/innerTable/OnlCgformInnerTableList"){
      componentPath = onlineCommons.OnlCgformInnerTableList
    }else if(item.component=="modules/online/cgreport/OnlCgreportHeadList"){
      componentPath = onlineCommons.OnlCgreportHeadList
    }else if(item.component=="modules/online/cgreport/auto/OnlCgreportAutoList"){
      componentPath = onlineCommons.OnlCgreportAutoList
    }else{
      componentPath = resolve => require(['@/' + component+'.vue'], resolve)
    }

    let menu =  {
      path: item.path,
      name: item.name,
      redirect:item.redirect,
      component: componentPath,
      //component: resolve => require(['@/' + component+'.vue'], resolve),
      hidden:item.hidden,
      //component:()=> import(`@/views/${item.component}.vue`),
      meta: {
        title:item.meta.title ,
        icon: item.meta.icon,
        url:item.meta.url ,
        permissionList:item.meta.permissionList,
        keepAlive:item.meta.keepAlive,
        /*update_begin author:wuxianquan date:20190908 for:赋值 */
        internalOrExternal:item.meta.internalOrExternal,
        /*update_end author:wuxianquan date:20190908 for:赋值 */
        componentName:item.meta.componentName
      }
    }
    if(item.alwaysShow){
      menu.alwaysShow = true;
      menu.redirect = menu.path;
    }
    if (item.children && item.children.length > 0) {
      menu.children = [...generateChildRouters( item.children)];
    }
    //--update-begin----author:scott---date:20190320------for:根据后台菜单配置，判断是否路由菜单字段，动态选择是否生成路由（为了支持参数URL菜单）------
    //判断是否生成路由
    if(item.route && item.route === '0'){
      //console.log(' 不生成路由 item.route：  '+item.route);
      //console.log(' 不生成路由 item.path：  '+item.path);
    }else{
      routers.push(menu);
    }
    //--update-end----author:scott---date:20190320------for:根据后台菜单配置，判断是否路由菜单字段，动态选择是否生成路由（为了支持参数URL菜单）------
  }
  return routers
}

/**
 * 深度克隆对象、数组
 * @param obj 被克隆的对象
 * @return 克隆后的对象
 */
export function cloneObject(obj) {
  return JSON.parse(JSON.stringify(obj))
}

/**
 * 随机生成数字
 *
 * 示例：生成长度为 12 的随机数：randomNumber(12)
 * 示例：生成 3~23 之间的随机数：randomNumber(3, 23)
 *
 * @param1 最小值 | 长度
 * @param2 最大值
 * @return int 生成后的数字
 */
export function randomNumber() {
  // 生成 最小值 到 最大值 区间的随机数
  const random = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min)
  }
  if (arguments.length === 1) {
    let [length] = arguments
  // 生成指定长度的随机数字，首位一定不是 0
    let nums = [...Array(length).keys()].map((i) => (i > 0 ? random(0, 9) : random(1, 9)))
    return parseInt(nums.join(''))
  } else if (arguments.length >= 2) {
    let [min, max] = arguments
    return random(min, max)
  } else {
    return Number.NaN
  }
}

/**
 * 随机生成字符串
 * @param length 字符串的长度
 * @param chats 可选字符串区间（只会生成传入的字符串中的字符）
 * @return string 生成的字符串
 */
export function randomString(length, chats) {
  if (!length) length = 1
  if (!chats) chats = '0123456789qwertyuioplkjhgfdsazxcvbnm'
  let str = ''
  for (let i = 0; i < length; i++) {
    let num = randomNumber(0, chats.length - 1)
    str += chats[num]
  }
  return str
}

/**
 * 随机生成uuid
 * @return string 生成的uuid
 */
export function randomUUID() {
  let chats = '0123456789abcdef'
  return randomString(32, chats)
}

/**
 * 下划线转驼峰
 * @param string
 * @returns {*}
 */
export function underLine2CamelCase(string){
  return string.replace( /_([a-z])/g, function( all, letter ) {
    return letter.toUpperCase();
  });
}

/**
 * 判断是否显示办理按钮
 * @param bpmStatus
 * @returns {*}
 */
export function showDealBtn(bpmStatus){
  if(bpmStatus!="1"&&bpmStatus!="3"&&bpmStatus!="4"){
    return true;
  }
  return false;
}

/**
 * 增强CSS，可以在页面上输出全局css
 * @param css 要增强的css
 * @param id style标签的id，可以用来清除旧样式
 */
export function cssExpand(css, id) {
  let style = document.createElement('style')
  style.type = "text/css"
  style.innerHTML = `@charset "UTF-8"; ${css}`
  // 清除旧样式
  if (id) {
    let $style = document.getElementById(id)
    if ($style != null) $style.outerHTML = ''
    style.id = id
  }
  // 应用新样式
  document.head.appendChild(style)
}


/** 用于js增强事件，运行JS代码，可以传参 */
// options 所需参数：
//    参数名         类型            说明
//    vm             VueComponent    vue实例
//    event          Object          event对象
//    jsCode         String          待执行的js代码
//    errorMessage   String          执行出错后的提示（控制台）
export function jsExpand(options = {}) {

  // 绑定到window上的keyName
  let windowKeyName = 'J_CLICK_EVENT_OPTIONS'
  if (typeof window[windowKeyName] != 'object') {
    window[windowKeyName] = {}
  }

  // 随机生成JS增强的执行id，防止冲突
  let id = randomString(16, 'qwertyuioplkjhgfdsazxcvbnm'.toUpperCase())
  // 封装按钮点击事件
  let code = `
    (function (o_${id}) {
      try {
        (function (globalEvent, vm) {
          ${options.jsCode}
        })(o_${id}.event, o_${id}.vm)
      } catch (e) {
        o_${id}.error(e)
      }
      o_${id}.done()
    })(window['${windowKeyName}']['EVENT_${id}'])
  `
  // 创建script标签
  const script = document.createElement('script')
  // 将需要传递的参数挂载到window对象上
  window[windowKeyName]['EVENT_' + id] = {
    vm: options.vm,
    event: options.event,
    // 当执行完成时，无论如何都会调用的回调事件
    done() {
      // 执行完后删除新增的 script 标签不会撤销执行结果（已产生的结果不会被撤销）
      script.outerHTML = ''
      delete window[windowKeyName]['EVENT_' + id]
    },
    // 当js运行出错的时候调用的事件
    error(e) {
      console.group(`${options.errorMessage || '用户自定义JS增强代码运行出错'}（${new Date()}）`)
      console.error(e)
      console.groupEnd()
    }
  }
  // 将事件挂载到document中
  script.innerHTML = code
  document.body.appendChild(script)
}


/**
 * 重复值验证工具方法
 *
 * 使用示例：
 * { validator: (rule, value, callback) => validateDuplicateValue('sys_fill_rule', 'rule_code', value, this.model.id, callback) }
 *
 * @param tableName 被验证的表名
 * @param fieldName 被验证的字段名
 * @param fieldVal 被验证的值
 * @param dataId 数据ID，可空
 * @param callback
 */
export function validateDuplicateValue(tableName, fieldName, fieldVal, dataId, callback) {
  if (fieldVal) {
    let params = { tableName, fieldName, fieldVal, dataId }
    api.duplicateCheck(params).then(res => {
      res['success'] ? callback() : callback(res['message'])
    }).catch(err => {
      callback(err.message || err)
    })
  } else {
    callback()
  }
}

/**
 * 根据编码校验规则code，校验传入的值是否合法
 *
 * 使用示例：
 * { validator: (rule, value, callback) => validateCheckRule('common', value, callback) }
 *
 * @param ruleCode 编码校验规则 code
 * @param value 被验证的值
 * @param callback
 */
export function validateCheckRule(ruleCode, value, callback) {
  if (ruleCode && value) {
    value = encodeURIComponent(value)
    api.checkRuleByCode({ ruleCode, value }).then(res => {
      res['success'] ? callback() : callback(res['message'])
    }).catch(err => {
      callback(err.message || err)
    })
  } else {
    callback()
  }
}

/**
 * 如果值不存在就 push 进数组，反之不处理
 * @param array 要操作的数据
 * @param value 要添加的值
 * @param key 可空，如果比较的是对象，可能存在地址不一样但值实际上是一样的情况，可以传此字段判断对象中唯一的字段，例如 id。不传则直接比较实际值
 * @returns {boolean} 成功 push 返回 true，不处理返回 false
 */
export function pushIfNotExist(array, value, key) {
  for (let item of array) {
    if (key && (item[key] === value[key])) {
      return false
    } else if (item === value) {
      return false
    }
  }
  array.push(value)
  return true
}

/**
 * 可用于判断是否成功
 * @type {symbol}
 */
export const succeedSymbol = Symbol()
/**
 * 可用于判断是否失败
 * @type {symbol}
 */
export const failedSymbol = Symbol()

/**
 * 使 promise 无论如何都会 resolve，除非传入的参数不是一个Promise对象或返回Promise对象的方法
 * 一般用在 Promise.all 中
 *
 * @param promise 可传Promise对象或返回Promise对象的方法
 * @returns {Promise<any>}
 */
export function alwaysResolve(promise) {
  return new Promise((resolve, reject) => {
    let p = promise
    if (typeof promise === 'function') {
      p = promise()
    }
    if (p instanceof Promise) {
      p.then(data => {
        resolve({ type: succeedSymbol, data })
      }).catch(error => {
        resolve({ type: failedSymbol, error })
      })
    } else {
      reject('alwaysResolve: 传入的参数不是一个Promise对象或返回Promise对象的方法')
    }
  })
}

/**
 * 简单实现防抖方法
 *
 * 防抖(debounce)函数在第一次触发给定的函数时，不立即执行函数，而是给出一个期限值(delay)，比如100ms。
 * 如果100ms内再次执行函数，就重新开始计时，直到计时结束后再真正执行函数。
 * 这样做的好处是如果短时间内大量触发同一事件，只会执行一次函数。
 *
 * @param fn 要防抖的函数
 * @param delay 防抖的毫秒数
 * @returns {Function}
 */
export function simpleDebounce(fn, delay = 100) {
  let timer = null
  return function () {
    let args = arguments
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      fn.apply(this, args)
    }, delay)
  }
}

/**
 * 不用正则的方式替换所有值
 * @param text 被替换的字符串
 * @param checker  替换前的内容
 * @param replacer 替换后的内容
 * @returns {String} 替换后的字符串
 */
export function replaceAll(text, checker, replacer) {
  let lastText = text
  text = text.replace(checker, replacer)
  if (lastText !== text) {
    return replaceAll(text, checker, replacer)
  }
  return text
}

/**
 * 获取事件冒泡路径，兼容 IE11，Edge，Chrome，Firefox，Safari
 * 目前使用的地方：JEditableTable Span模式
 */
export function getEventPath(event) {
  let target = event.target
  let path = (event.composedPath && event.composedPath()) || event.path

  if (path != null) {
    return (path.indexOf(window) < 0) ? path.concat(window) : path
  }

  if (target === window) {
    return [window]
  }

  let getParents = (node, memo) => {
    memo = memo || []
    const parentNode = node.parentNode

    if (!parentNode) {
      return memo
    } else {
      return getParents(parentNode, memo.concat(parentNode))
    }
  }
  return [target].concat(getParents(target), window)
}

/**
 * 根据组件名获取父级
 * @param vm
 * @param name
 * @returns {Vue | null|null|Vue}
 */
export function getVmParentByName(vm, name) {
  let parent = vm.$parent
  if (parent && parent.$options) {
    if (parent.$options.name === name) {
      return parent
    } else {
      let res = getVmParentByName(parent, name)
      if (res) {
        return res
      }
    }
  }
  return null
}

/**
 * 使一个值永远不会为（null | undefined）
 *
 * @param value 要处理的值
 * @param def 默认值，如果value为（null | undefined）则返回的默认值，可不传，默认为''
 */
export function neverNull(value, def) {
  return value == null ? (neverNull(def, '')) : value
}

/**
 * 根据元素值移除数组中的一个元素
 * @param array 数组
 * @param prod 属性名
 * @param value 属性值
 * @returns {string}
 */
export function removeArrayElement(array, prod, value) {
  let index = -1
  for(let i = 0;i<array.length;i++){
    if(array[i][prod] == value){
      index = i;
      break;
    }
  }
  if(index>=0){
    array.splice(index, 1);
  }
}

/**
 * 将涉及到金额的值由分转化为元或者元转化为分
 *
 * @param value 要处理的值
 * @param type  转化方式 1表示分转化为元 2表示元转化为分
 */
export function moneyFormat(value, type) {
  if(type==1){
    return parseFloat(value/100).toFixed(2);
  }
  return parseInt(value*100);
}

export function tuoMin(text){
  if(!text){

    return text;
  }
  if(text.length<=7){
    return text;
  }
  let val ='';
  if(text){
    var arr =text.split(",");
    for(var k in arr){
      val += "，"+arr[k].substring(0,3)+"****"+arr[k].substring(arr[k].length-4,arr[k].length);
    }
    val = val.substring(1);
  }
  return val;
}

export function returnCallTime(text,end){
  var sTime = new Date(text).getTime(); //开始时间
  if(!end){
    end = new Date();
  }else{
    if(typeof end == 'string'){
      end = new Date(end);
    }
  }
  var eTime = end.getTime();  //结束时间
  //作为除数的数字
  var divNumSecond = 1000;
  var divNumMinute = 1000 * 60;
  var divNumHour = 1000 * 3600;
  var divNumDay = 1000 * 3600 * 24;

  const day = parseInt((eTime - sTime) / parseInt(divNumDay))
  const hour = parseInt(((eTime - sTime) % parseInt(divNumDay)) / parseInt(divNumHour))
  const minute = parseInt((parseInt(((eTime - sTime) % parseInt(divNumDay)) % parseInt(divNumHour))) / parseInt(divNumMinute))
  const second = ((parseInt(((eTime - sTime) % parseInt(divNumDay)) % parseInt(divNumHour))) % parseInt(divNumMinute)) / parseInt(divNumSecond)
  let str = '';
  if(day>0){
    str += day + '天'
  }
  if(str ||hour>0){
    str += hour + '小时'
  }
  if(str ||minute>0){
    str += minute + '分'
  }
  if(str ||parseInt(second)>0){
    str += parseInt(second) + '秒'
  }
  if(!str){
    str = "0秒"
  }
  return str
}


export function returnDays(text,end){
  console.log(text)
  var sTime = new Date(text+" 00:00:00").getTime(); //开始时间
  if(!end){
    end = new Date();
  }else{
    if(typeof end == 'string'){
      end = new Date(end+" 00:00:00");
    }
  }
  var eTime = end.getTime();  //结束时间
  var divNumDay = 1000 * 3600 * 24;

  const day = parseInt((eTime - sTime) / parseInt(divNumDay))
  let str = day + '天'
  return str
}



export function returnCallTimeEng(text,end){
  var sTime = new Date(text).getTime(); //开始时间
  if(!end){
    end = new Date();
  }else{
    if(typeof end == 'string'){
      end = new Date(end);
    }
  }
  var eTime = end.getTime();  //结束时间
  //作为除数的数字
  var divNumMinute = 1000 * 60;
  var divNumHour = 1000 * 3600;
  var divNumDay = 1000 * 3600 * 24;

  const day = parseInt((eTime - sTime) / parseInt(divNumDay))
  const hour = parseInt(((eTime - sTime) % parseInt(divNumDay)) / parseInt(divNumHour))
  const minute = parseInt((parseInt(((eTime - sTime) % parseInt(divNumDay)) % parseInt(divNumHour))) / parseInt(divNumMinute))
  let str = '';
  if(day>0){
    str += day + 'd '
  }
  if(str ||hour>0){
    str += hour + 'h '
  }
  if(str ||minute>0){
    str += minute + 'm '
  }
  if(!str){
    return '0m'
  }
  return str
}

export function returnTimestempSub(start,end){
  var sTime = new Date(start).getTime(); //开始时间
  var eTime = new Date().getTime();  //结束时间
  if(end){
    eTime = new Date(end).getTime();
  }
  return parseInt(eTime - sTime);
}

export function returnCallTimeSub(text,days){
  var sTime = new Date(text).getTime(); //开始时间
  var eTime = new Date().getTime();  //结束时间
  //作为除数的数字
  var divNumSecond = 1000;
  var divNumMinute = 1000 * 60;
  var divNumHour = 1000 * 3600;
  var divNumDay = 1000 * 3600 * 24;

  let cha = days *  24 *3600 *1000 -(eTime - sTime);
  if(cha<0){
    cha = 0;
  }
  const day = parseInt((cha) / parseInt(divNumDay))
  const hour = parseInt(((cha) % parseInt(divNumDay)) / parseInt(divNumHour))
  const minute = parseInt((parseInt(((cha) % parseInt(divNumDay)) % parseInt(divNumHour))) / parseInt(divNumMinute))
  const second = ((parseInt(((cha) % parseInt(divNumDay)) % parseInt(divNumHour))) % parseInt(divNumMinute)) / parseInt(divNumSecond)
  let str = '';
  if(day>0){
    str += day + '天'
  }
  if(str ||hour>0){
    str += hour + '小时'
  }
  if(str ||minute>0){
    str += minute + '分'
  }
  if(str ||parseInt(second)>0){
    str += parseInt(second) + '秒'
  }
  return str
}

export function evalCallTime(text){
  var sTime = new Date(text).getTime(); //开始时间
  var eTime = new Date().getTime();  //结束时间
  //作为除数的数字
  var divNumSecond = 1000;
  var divNumMinute = 1000 * 60;
  var divNumHour = 1000 * 3600;
  var divNumDay = 1000 * 3600 * 24;

  const minute = parseInt(parseInt(eTime - sTime) / divNumMinute)
  const second = ((parseInt(((eTime - sTime) % parseInt(divNumDay)) % parseInt(divNumHour))) % parseInt(divNumMinute)) / parseInt(divNumSecond)
  let str = '';

  if(str ||minute>0){
    let hst = ""
    if(minute<10){
      hst = "0"+minute;
    }else {
      hst = ""+minute
    }
    str += hst + ':'
  }else{
    str += '00:'
  }
  if(str ||parseInt(second)>0){
    let hst = ""
    if(parseInt(second)<10){
      hst = "0"+parseInt(second);
    }else {
      hst = ""+parseInt(second)
    }
    str += hst
  }else{
    str += "00";
  }
  return str
}




export function evalCallTimeTwo(start,end){
  var sTime = new Date(start).getTime(); //开始时间
  var eTime = new Date(end).getTime();  //结束时间
  //作为除数的数字
  var divNumSecond = 1000;
  var divNumMinute = 1000 * 60;
  var divNumHour = 1000 * 3600;
  var divNumDay = 1000 * 3600 * 24;

  const minute = parseInt(parseInt(eTime - sTime) / divNumMinute)
  const second = ((parseInt(((eTime - sTime) % parseInt(divNumDay)) % parseInt(divNumHour))) % parseInt(divNumMinute)) / parseInt(divNumSecond)
  let str = '';

  if(str ||minute>0){
    let hst = ""
    if(minute<10){
      hst = "0"+minute;
    }else {
      hst = ""+minute
    }
    str += hst + ':'
  }else{
    str += '00:'
  }
  if(str ||parseInt(second)>0){
    let hst = ""
    if(parseInt(second)<10){
      hst = "0"+parseInt(second);
    }else {
      hst = ""+parseInt(second)
    }
    str += hst
  }else{
    str += "00";
  }
  return str
}


export function getDataSub(max,min){
  if(typeof max == 'string'){
    max = new Date(max.replace(/-/g,"/"));
  }
  if(typeof min == 'string'){
    min = new Date(min.replace(/-/g,"/"));
  }

  var times=max.getTime()-min.getTime();
  let days = parseInt(times/(24*1000*3600));
  if(days>0){
    return days+"天";
  }
  var h=parseInt(times/(3600*1000));
  if(h>0){
    return h+"小时";
  }
  var sec=parseInt(times/(60*1000));
  return sec+"分钟";
}
export function getTimesteampSubTime(time){
  time = new Date(time.replace(/-/g,"/"))
  let now  = new Date();
  return getTimesteampSub(now.getTime()- time.getTime())
}

export function getTimesteampSub(times){
  if(!times){
    return "0秒";
  }
  let days = parseInt(times/(24*1000*3600));
  if(days>0){
    return days+"天";
  }
  var h=parseInt(times/(3600*1000));
  if(h>0){
    return h+"小时";
  }
  var sec=parseInt(times/(60*1000));
  if(sec>0){
    return sec+"分钟";
  }
  var m=parseInt(times/1000);
  return m+"秒";
}

export  function getDateYearSub(startDateStr, endDateStr) {
  var day = 24 * 60 * 60 *1000;

  var sDate = new Date(Date.parse(startDateStr.replace(/-/g, "/")));
  var eDate = new Date(Date.parse(endDateStr.replace(/-/g, "/")));

  //得到前一天(算头不算尾)
  sDate = new Date(sDate.getTime() - day);

  var sY = sDate.getFullYear();
  var sM = sDate.getMonth() + 1;
  var sD = sDate.getDate();
  var eY = eDate.getFullYear();
  var eM = eDate.getMonth() + 1;
  var eD = eDate.getDate();

  var yL = eY - sY;
  var mL = eM - sM;
  var dL = eD - sD;

  if (dL < 0) {
    mL--;
  }
  if (mL < 0) {
    yL--;
  }
  if (yL > 0) {
    return yL;
  }else{
    return 0;
  }
}


export const formatSearchConetnt = (text,search) => {
  if(!search){
    return text;
  }
  if(!text){
    return text;
  }
  return text.replace(eval('/'+search+'/g'),'<span style="color: rgba(42, 130, 228, 1); ">'+search+'</span>');

}



/**
 * 排序，按指定的属性值排序
 * @param name
 * @param minor
 * @returns {Function}
 */
export function by_str(name, minor) {
  return function(o, p) {
    var a, b;
    if (typeof o === "object" && typeof p === "object" && o && p) {
      a = o[name];
      b = p[name];
      if (a === b) {
        return typeof minor === 'function' ? minor(o, p) : 0;
      }
      if (typeof a === typeof b) {
        if(isNaN(a) && isNaN(b)){
          return a < b ? -1 : 1;
        }else{
          return Number(a) < Number(b) ? -1 : 1;
        }
      }
      return typeof a < typeof b ? -1 : 1;
    }
  }
}


/**
 * 将对像进行排序
 * @param obj 对象
 * @param name 排序属性名
 * @param minor 子排序
 * @param desc 排序方式 desc 降序 asc
 * @returns 返回排序好的对象数组
 */
export function obj_sort_by(obj,name,minor){
  var tmp = [];
  for(var k in obj){
    tmp.push(obj[k]);
  }
  tmp.sort(by_str(name,minor));
  return tmp;
}


